import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  scrollToTop(event) {
    if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
    if (event.button && event.button !== 0) return

    const link = event.target.closest("a")
    if (!link || !this.element.contains(link)) return

    window.scrollTo({ top: 0, left: 0, behavior: "auto" })
  }
}
